import { action } from '@ember/object';
import Component from '@glimmer/component';
import type { Changeset } from 'ember-form-changeset-validations/types/typed-changeset';

interface InputsPhoneValidationComponentArgs {
  changeset: Changeset;
  validationField: string;
  type: string;
  onChange?: (value: string) => unknown;
}

export default class InputsPhoneValidationComponent extends Component<InputsPhoneValidationComponentArgs> {
  maskPhone = {
    mask: '+00 000000000',
    lazy: true,
  };
  @action
  onChange(e: string) {
    const value = e.replaceAll('_', '').trim();
    if (value.match(/^\+3\d{0,1}$/)) {
      this.args.changeset.set(this.args.validationField, '');
      return;
    }
    this.args.changeset.set(this.args.validationField, value);
  }
}
